import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AgentStatus } from '../../_constants/agent.constant';
import { loaderActions } from '../../_actions/loader.actions';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../components/commonClass/Session';
import CreateTravelAgent from '../TravelAgentManagement/partial/CreateTravelAgent';
import CreateCorporate from '../CorporateManagement/partial/CreateCorporate';
import './NewLoginScreen.css';

const Onboarding = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user: any = GetLocalStorage();
    const [userData, setUserData] = useState<any>(null);
    const [status, setStatus] = useState<number>(0);
    const [DomainType, setDomainType] = useState<number>(0); // 2: TA, 3: Corporate

    useEffect(() => {
        dispatch(loaderActions.end());
        if (user && typeof user === 'object') {
            setUserData(user);
            setDomainType(user.domainMasterId);
            setStatus(user.statusId || 0);
        }
    }, []);

    const handleLogout = () => {
        ClearLocalStorage();
        navigate('/');
    };

    const renderStatusLabel = () => {
        switch (status) {
            case AgentStatus.Pending: // Pending
                return (
                    <div className="alert alert-info w-100 mb-3" style={{ backgroundColor: '#ffc107', color: '#000', border: 'none' }}>
                        <i className="bi bi-info-circle me-2"></i>
                        Your application is currently pending review.
                    </div>
                );
            case AgentStatus.Submit: // Submitted
                return (
                    <div className="alert w-100 mb-3" style={{ backgroundColor: '#ecc203', color: '#fff', border: 'none' }}>
                        <i className="bi bi-check2-circle me-2"></i>
                        Your application successfully submitted
                    </div>
                );
            case AgentStatus.Rejected: // Rejected
                return (
                    <div className="alert alert-danger w-100 mb-3" style={{ backgroundColor: '#d32f2f', color: '#fff', border: 'none' }}>
                        <i className="bi bi-exclamation-octagon me-2"></i>
                        Your application has been rejected. Please review and resubmit.
                    </div>
                );
            case AgentStatus.ReSubmit: // Rejected
                return (
                    <div className="alert alert-danger w-100 mb-3" style={{ backgroundColor: '#d32f2f', color: '#fff', border: 'none' }}>
                        <i className="bi bi-exclamation-octagon me-2"></i>
                        Your application has been ReSubmitted..
                    </div>
                );
            default:
                return null;
        }
    };

    if (!userData) return <div>Loading...</div>;
    return (
        <div className="onboarding-container p-3">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 mt-5">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h4 className="fw-bold">{DomainType === 2 ? 'Travel Agent Management' : 'Corporate Management'}</h4>
                        </div>
                        {renderStatusLabel()}
                    </div>
                </div>

                <div className="onboarding-card">
                    {DomainType === 2 ? (
                        <CreateTravelAgent statusId={user?.statusId} isOnBording={1} setAgentStatusId={setStatus} />
                    ) : DomainType === 3 ? (
                        <CreateCorporate statusId={user?.statusId} isOnBording={1} setCorporateStatusId={setStatus} />
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Onboarding;
